import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
    theme: "light",
    setTheme: () => { },
});

export function ThemeProvider({ children, attribute = "class", defaultTheme = "light", enableSystem = true, disableTransitionOnChange = false }) {
    const [theme, setThemeState] = useState(defaultTheme);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        setThemeState("light");
    }, []);

    useEffect(() => {
        if (!mounted) return;

        const root = document.documentElement;

        if (disableTransitionOnChange) {
            root.classList.add("no-transition");
        }

        if (attribute === "class") {
            root.classList.remove("dark");
            root.classList.add("light");
        }

        // localStorage.setItem("theme", theme); // Disabled to prevent saving theme preference

        if (disableTransitionOnChange) {
            setTimeout(() => {
                root.classList.remove("no-transition");
            }, 0);
        }
    }, [theme, attribute, disableTransitionOnChange, mounted]);

    const setTheme = (newTheme) => {
        // setThemeState(newTheme); // Disabled to force light mode
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error("useTheme must be used within ThemeProvider");
    }
    return context;
}
